import { msg } from '@/shared/i18n/msg';
import type { InventoryFilter, InventorySort } from '../schemas/inventory-filter';

export const INVENTORY_FILTER_OPTIONS: {
  readonly filters: readonly { readonly value: InventoryFilter; readonly label: string }[];
  readonly sorts: readonly { readonly value: InventorySort; readonly label: string }[];
} = {
  filters: [
    { value: 'all', label: msg('All') },
    { value: 'attention', label: msg('Expiring soon') },
    { value: 'expired', label: msg('Expired') },
    { value: 'low', label: msg('Low stock') },
  ],
  sorts: [
    { value: 'due', label: msg('By due date') },
    { value: 'name', label: msg('By name') },
    { value: 'location', label: msg('By location') },
  ],
};
